import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import useCustomerFilters from '../../resources/customers/components/CustomerFilterHelper';
import { useGetCustomersHandler } from '../../resources/customers/dataHandlers/getCustomersHandler';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';
import { getFieldErrorMessage } from '../../utils/apiFieldErrors';

const CustomerSelect = ({ label, name, control, errors, readOnly = false, onCustomerLoaded }) => {
  const { common } = useTranslatedMessages();
  const customerSelect = common.customer_select ?? {};
  const resolvedLabel = label ?? customerSelect.label;
  const { currentQuery, handleSearchChange } = useCustomerFilters({ defaultQuery: {}, searchOnChange: true });

  const { customers, isLoading } = useGetCustomersHandler({ searchQuery: currentQuery });
  const errorMessage = getFieldErrorMessage(errors, name);

  useEffect(() => {
    if (customers) {
      onCustomerLoaded?.(customers);
    }
  }, [customers, onCustomerLoaded]);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Box display="flex" alignItems="flex-start" gap={2}>
            <Autocomplete
              {...field}
              id={name}
              fullWidth
              loading={isLoading}
              readOnly={readOnly}
              options={customers}
              getOptionLabel={(option) =>
                `${option?.name || '-'} | ${option?.email || '-'} | ${option?.company_id || '-'}`
              }
              getOptionKey={(option) => option?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={resolvedLabel}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              onChange={(_, value) => field.onChange(value)}
              value={field?.value || null}
              onInputChange={(event, value, reason) => {
                if (reason === 'input') {
                  handleSearchChange(event);
                }
              }}
              filterOptions={(x) => x}
            />
            {/*//Todo : - remove this button if we dont support add customer at document creation*/}
            {/*{!readOnly && (*/}
            {/*  <Button id="add-customer" variant="contained" color="primary" sx={{ py: 1 }} onClick={handleOpen}>*/}
            {/*    Add*/}
            {/*  </Button>*/}
            {/*)}*/}
          </Box>
        )}
      />
      {/*{open && <CustomerPopupModal open={open} handleClose={handleClose} onSave={onSelect} setError={setError} />}*/}
    </>
  );
};

export default CustomerSelect;
